import { createFileRoute } from '@tanstack/react-router'
import { SignaturesHub } from '@/features/signatures/signatures-hub'

export const Route = createFileRoute(
  '/_authenticated/_organization/signatures',
)({
  component: SignaturesHub,
})
